import { useState, useCallback } from "react";
import { Drawer, IconButton, Menu, MenuItem, Collapse } from "@mui/material";
import { Menu as MenuIcon, ShoppingCart, Heart, PhoneCall, LockOpen, ChevronDown, ChevronUp, UserIcon, UserPlus, Globe } from "lucide-react";
import { Home, Store, Info, Phone, Drumstick } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoPk from "../../assets/WebpImages/aliffarms-pk.webp";
import NavLogo2 from "../../assets/images/NewLogoAmerica.jpg";
import Logo2 from '../../assets/images/NewLogoAmerica.jpg'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useUser } from "../../context/useUser";
import { useCart } from "../../context/useCart";
import { useLoading } from '../../context/LoadingContext'
import { useWishlist } from '../../context/useWishList'
import Tooltip from '@mui/material/Tooltip';


const Navbar = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorE2, setAnchorE2] = useState(null);
    const [anchorE3, setAnchorE3] = useState(null);
    const [shopOpen, setShopOpen] = useState(false);
    const [qurbaniOpen, setQurbaniOpen] = useState(false);
    const { country } = useUser()
    const { showLoader, hideLoader } = useLoading()
    const { setWishlist, wishlist } = useWishlist()
    const open = Boolean(anchorEl);
    const openAuth = Boolean(anchorE2);
    const openQurbani = Boolean(anchorE3);
    const location = useLocation();
    const navigate = useNavigate()
    const { cart, setCart } = useCart()
    const isActive = useCallback((path) => location.pathname === path, [location.pathname]);
    const isMobile = useMediaQuery('(max-width:1020px)');

    const toggleDrawer = useCallback((open) => {
        setMobileOpen(open);
    }, []);

    const handleMenuClick = useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const handleMenuClose = useCallback(() => {
        setTimeout(() => setAnchorEl(null), 100);
    }, []);

    const handleMenuClickForAuth = (event) => {
        setAnchorE2(event.currentTarget);
    };

    const handleMenuCloseForAuth = () => {
        setAnchorE2(null);
    };

    const handleMenuClickForQurbani = (event) => {
        setAnchorE3(event.currentTarget);
    };

    const handleMenuCloseForQurbani = () => {
        setAnchorE3(null);
    };

    const changeRegion = () => {
        setAnchorE2(null);
        showLoader()
        setTimeout(() => {
            setCart([])
            setWishlist([])
            localStorage.removeItem('region')
            localStorage.removeItem('regionExpiry')
            localStorage.removeItem('wishlist')
            localStorage.removeItem('cart')
            hideLoader()
            navigate('/country-version')
            sessionStorage.removeItem("hasSeenModal")
        }, 2500)
    }

    return (
        <nav className="sticky top-0 z-[1000] bg-white">
            <div className={`bg-white  h-[65px] mx-auto w-full max-w-[1400px] px-3 md:px-6 flex justify-between items-center`}>
                <div onClick={() => { navigate("/") }} className="text-xl font-[600] cursor-pointer flex items-center">
                    <img src={country === "PK" ? LogoPk : NavLogo2} alt="Logo" className={`${country === "PK" ? "h-[60px]" : "h-[60px]"} mr-2 `} />
                    <span className="hidden md:block text-xl">{country === "PK" ? "Alif Cattle & Goat Farm" : "Alif Meat Packing"}</span>
                </div>
                <div className={`${isMobile ? "hidden" : "flex"} items-center text-[15px] font-[500] space-x-4 gap-6 text-gray-700`}>
                    <Link to="/" className={`${country === "PK" ? "hover:text-[#8a2e25]" : "hover:text-[#65754d]"}   ${isActive("/") ? `${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} ` : "text-[#000000]"}`}>
                        Home
                    </Link>
                    <div>
                        <button
                            onClick={handleMenuClick}
                            className={`${country === "PK" ? "hover:text-[#8a2e25]" : "hover:text-[#65754d]"} cursor-pointer flex items-center ${(isActive("/shop/chicken") || isActive("/shop/mutton") || isActive("/shop/beef")) ? `${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} ` : "text-[#000000]"}`}
                        >
                            Shop {open ? <ChevronUp size={18} className="relative top-[1px] left-[3px]" /> : <ChevronDown size={18} className="relative  top-[1px] left-[3px]" />}
                        </button>
                        {typeof window !== "undefined" && (
                            <Menu
                                sx={{
                                    width: "200px",
                                    borderRadius: "8px",
                                    mt: 1,
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleMenuClose}
                            >
                                <MenuItem
                                    component={Link}
                                    to="/shop/chicken"
                                    onClick={handleMenuClose}
                                    sx={{
                                        color: isActive("/shop/chicken") ? `${country === "PK" ? "#8a2e25" : "#65754d"}` : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: `${country === "PK" ? "#8a2e25" : "#65754d"}` },
                                    }}
                                >
                                    🐔 Chicken
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to="/shop/mutton"
                                    onClick={handleMenuClose}
                                    sx={{
                                        color: isActive("/shop/mutton") ? `${country === "PK" ? "#8a2e25" : "#65754d"}` : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: `${country === "PK" ? "#8a2e25" : "#65754d"}` },
                                    }}
                                >
                                    🐑 Mutton
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to="/shop/beef"
                                    onClick={handleMenuClose}
                                    sx={{
                                        color: isActive("/shop/beef") ? `${country === "PK" ? "#8a2e25" : "#65754d"}` : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: `${country === "PK" ? "#8a2e25" : "#65754d"}` },
                                    }}
                                >
                                    🐄 Beef
                                </MenuItem>
                            </Menu>
                        )}

                    </div>
                    <div>
                        <button
                            onClick={handleMenuClickForQurbani}
                            className={`${country === "PK" ? "hover:text-[#8a2e25]" : "hover:text-[#65754d]"} cursor-pointer flex items-center ${(isActive("/book-your-qurbani") || isActive("/donate-qurbani")) ? `${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} ` : "text-[#000000]"}`}
                        >
                            Qurbani {openQurbani ? <ChevronUp size={18} className="relative top-[1px] left-[3px]" /> : <ChevronDown size={18} className="relative  top-[1px] left-[3px]" />}
                        </button>
                        {typeof window !== "undefined" && (
                            <Menu
                                sx={{
                                    width: "200px",
                                    borderRadius: "8px",
                                    mt: 1,
                                }}
                                anchorEl={anchorE3}
                                open={openQurbani}
                                onClose={handleMenuCloseForQurbani}
                            >
                                <MenuItem
                                    component={Link}
                                    to="/book-your-qurbani"
                                    onClick={handleMenuCloseForQurbani}
                                    sx={{
                                        color: isActive("/book-your-qurbani") ? `${country === "PK" ? "#8a2e25" : "#65754d"}` : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: `${country === "PK" ? "#8a2e25" : "#65754d"}` },
                                    }}
                                >
                                    Book your Qurbani
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to="/donate-qurbani"
                                    onClick={handleMenuCloseForQurbani}
                                    sx={{
                                        color: isActive("/donate-qurbani") ? `${country === "PK" ? "#8a2e25" : "#65754d"}` : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: `${country === "PK" ? "#8a2e25" : "#65754d"}` },
                                    }}
                                >
                                    Donate Qurbani
                                </MenuItem>
                            </Menu>
                        )}

                    </div>
                    <Link to="/about-us" className={`${country === "PK" ? "hover:text-[#8a2e25]" : "hover:text-[#65754d]"}   ${isActive("/about-us") ? `${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} ` : "text-[#000000]"}`}>
                        About Us
                    </Link>
                    <Link to="/contact-us" className={`${country === "PK" ? "hover:text-[#8a2e25]" : "hover:text-[#65754d]"}   ${isActive("/contact-us") ? `${country === "PK" ? "text-[#8a2e25]" : "text-[#65754d]"} ` : "text-[#000000]"}`}>
                        Contact Us
                    </Link>
                </div>
                <div className="flex gap-2">
                    <div className="flex text-[14px] font-[500] items-center gap-6">
                        <Tooltip
                            arrow
                            title="Contact Us"
                            placement="bottom"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#ffffff',
                                        color: '#000000',
                                        padding: '8px 12px',
                                        borderRadius: 0,
                                        boxShadow: 2,
                                        fontSize: '13px'
                                    },
                                    className: 'custom-tooltip',
                                },
                            }}
                        >
                            <div className="hidden md:flex items-center gap-1">
                                <PhoneCall size={16} />
                                {country === "PK" ? (
                                    <a href="tel:+923052023333">
                                        <span>0305-2023333</span>
                                    </a>
                                ) : (
                                    <a href="tel:+1888321ALIF">
                                        <span>(888)321-ALIF</span>
                                    </a>
                                )}
                            </div>
                        </Tooltip>
                        <Tooltip
                            arrow
                            title="Your Wishlist"
                            placement="bottom"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#ffffff',
                                        color: '#000000',
                                        padding: '8px 12px',
                                        borderRadius: 0,
                                        boxShadow: 2,
                                        fontSize: '13px'
                                    },
                                    className: 'custom-tooltip',
                                },
                            }}
                        >
                            <div onClick={() => { navigate('/wishlist') }} className="relative cursor-pointer">
                                <Heart size={22} />
                                {(Array.isArray(wishlist) && wishlist.length > 0) ? (
                                    <span className="absolute -top-2 -right-2 bg-red-400 text-white text-xs rounded-full p-1.5 w-[15px] flex justify-center items-center h-[15px]">
                                        {wishlist.length}
                                    </span>
                                ) : null}
                            </div>
                        </Tooltip>
                        <Tooltip
                            arrow
                            title="Shopping Cart"
                            placement="bottom"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#ffffff',
                                        color: '#000000',
                                        padding: '8px 12px',
                                        borderRadius: 0,
                                        boxShadow: 2,
                                        fontSize: '13px'
                                    },
                                    className: 'custom-tooltip',
                                },
                            }}
                        >
                            <div onClick={() => { navigate('/cart') }} className="relative cursor-pointer">
                                <ShoppingCart size={22} />
                                {(Array.isArray(cart) && cart.length > 0) ? (
                                    <span className="absolute -top-2 -right-2 bg-[#3f8e42] text-white text-xs rounded-full p-1.5 w-[15px] flex justify-center items-center h-[15px]">
                                        {cart.length}
                                    </span>
                                ) : null}
                            </div>
                        </Tooltip>
                        <Tooltip
                            arrow
                            title="Change Region"
                            placement="bottom"
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#ffffff',
                                        color: '#000000',
                                        padding: '8px 12px',
                                        borderRadius: 0,
                                        boxShadow: 2,
                                        fontSize: '13px'
                                    },
                                    className: 'custom-tooltip',
                                },
                            }}
                        >
                            <div onClick={changeRegion} className="relative cursor-pointer">
                                <Globe size={22} />
                            </div>
                        </Tooltip>
                        <div>
                            <Tooltip
                                arrow
                                title="Profile"
                                placement="bottom"
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            padding: '8px 12px',
                                            borderRadius: 0,
                                            boxShadow: 2,
                                            fontSize: '13px'
                                        },
                                        className: 'custom-tooltip',
                                    },
                                }}
                            >
                                <button
                                    onClick={handleMenuClickForAuth}
                                    className="cursor-pointer flex items-center"
                                >
                                    <UserIcon />
                                </button>
                            </Tooltip>
                            <Menu
                                anchorEl={anchorE2}
                                open={openAuth}
                                onClose={handleMenuCloseForAuth}
                                sx={{
                                    width: "200px",
                                    borderRadius: "8px",
                                    mt: 1,
                                }}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                            >
                                <MenuItem
                                    component={Link}
                                    to="/auth"
                                    onClick={handleMenuCloseForAuth}
                                    sx={{
                                        color: isActive("/auth") ? "#944038" : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: "#944038" },
                                    }}
                                >
                                    <LockOpen size={20} className="mr-3" /> Sign In
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to="/signup"
                                    onClick={handleMenuCloseForAuth}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: isActive("/signup") ? "#944038" : "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: "#944038" },
                                    }}
                                >
                                    <UserPlus size={24} className="mr-3" />
                                    Create Account
                                </MenuItem>
                                {/* <MenuItem
                                    onClick={changeRegion}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: "#808080",
                                        fontWeight: 500,
                                        px: 2,
                                        py: 1.5,
                                        "&:hover": { backgroundColor: "#f5f5f5", color: "#944038" },
                                    }}
                                >
                                    <Globe size={24} className="mr-3" />
                                    Change Region
                                </MenuItem> */}
                            </Menu>
                        </div>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className={`${isMobile ? "block" : "hidden"}`}>
                        <IconButton onClick={() => toggleDrawer(true)}>
                            <MenuIcon size={24} />
                        </IconButton>
                    </div>
                </div>

                {/* Mobile Sidebar */}
                <Drawer anchor="left" open={mobileOpen} onClose={() => toggleDrawer(false)}>
                    <div className="w-72 bg-white h-full flex flex-col">
                        {/* Logo */}
                        <div className={`flex justify-center ${country === "PK" ? "py-0" : ""}`}>
                            <img src={country === "PK" ? LogoPk : Logo2} alt="Logo" className={`${country === "PK" ? "h-full w-full relative bottom-6 border-none" : ""}`} />
                        </div>

                        {/* Navigation Links */}
                        <div className="p-5 text-[15px] font-medium text-gray-700 flex flex-col gap-4">
                            <Link
                                to="/"
                                onClick={() => toggleDrawer(false)}
                                className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"}`}
                            >
                                <Home size={20} />
                                Home
                            </Link>

                            {/* Shop Dropdown */}
                            <div>
                                <button
                                    onClick={() => setShopOpen(!shopOpen)}
                                    className={`flex items-center w-full text-left p-2 gap-3 rounded-md transition-all ${isActive("/shop") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                        }`}
                                >
                                    <Store size={20} />
                                    <span className="flex-1">Shop</span>
                                    {shopOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                </button>

                                <Collapse in={shopOpen}>
                                    <div className="pl-6 mt-2 flex flex-col gap-2">
                                        <Link
                                            to="/shop/chicken"
                                            onClick={() => toggleDrawer(false)}
                                            className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/shop/chicken") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                                }`}
                                        >
                                            <Drumstick size={18} />
                                            Chicken
                                        </Link>
                                        <Link
                                            to="/shop/mutton"
                                            onClick={() => toggleDrawer(false)}
                                            className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/shop/mutton") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                                }`}
                                        >
                                            🐑
                                            Mutton
                                        </Link>
                                        <Link
                                            to="/shop/beef"
                                            onClick={() => toggleDrawer(false)}
                                            className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/shop/beef") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                                }`}
                                        >
                                            🐄
                                            Beef
                                        </Link>
                                    </div>
                                </Collapse>
                            </div>
                            {/* Shop Dropdown */}
                            <div>
                                <button
                                    onClick={() => setQurbaniOpen(!qurbaniOpen)}
                                    className={`flex items-center w-full text-left p-2 gap-3 rounded-md transition-all ${isActive("/shop") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                        }`}
                                >
                                    <Store size={20} />
                                    <span className="flex-1">Qurbani</span>
                                    {qurbaniOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                </button>

                                <Collapse in={qurbaniOpen}>
                                    <div className="pl-6 mt-2 flex flex-col gap-2">
                                        <Link
                                            to="/book-your-qurbani"
                                            onClick={() => toggleDrawer(false)}
                                            className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/book-your-qurbani") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                                }`}
                                        >
                                            Book your qurbani
                                        </Link>
                                        <Link
                                            to="/donate-qurbani"
                                            onClick={() => toggleDrawer(false)}
                                            className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/donate-qurbani") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                                }`}
                                        >
                                            Donate qurbani
                                        </Link>
                                    </div>
                                </Collapse>
                            </div>
                            <Link
                                to="/about-us"
                                onClick={() => toggleDrawer(false)}
                                className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/about-us") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                    }`}
                            >
                                <Info size={20} />
                                About Us
                            </Link>

                            <Link
                                to="/contact-us"
                                onClick={() => toggleDrawer(false)}
                                className={`flex items-center gap-3 p-2 rounded-md transition-all ${isActive("/contact-us") ? (country === "PK" ? "bg-[#944038] text-white" : "bg-[#64734c] text-white") : "hover:bg-gray-100"
                                    }`}
                            >
                                <Phone size={20} />
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </Drawer>
            </div>
        </nav >
    );
};

export default Navbar;
